import { makeStyles } from "@material-ui/core";

const completeProfileStyle = makeStyles(theme => ({
  skipButton: {
    color: "#f06ec4",
    fontSize: "14px",
    textDecoration: "none",
    cursor: "pointer",
    textTransform: "none",
    padding: 0,
    borderRadius: 0,
    lineHeight: 0.9,
    borderBottom: "1px solid #f06ec4",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    minHeight: "100vh",
    padding: "20px",
    backgroundColor: "#000000",
  },
  title: {
    color: "#ffffff",
    fontSize: "28px",
    fontWeight: 700,
    marginBottom: "10px",
  },
  progressContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    maxWidth: "600px",
    marginBottom: "40px",
  },
  progressStep: {
    width: "14px",
    height: "14px",
    borderRadius: "50%",
    backgroundColor: "#4a4a4a",
    margin: "0 8px",
  },
  activeStep: {
    backgroundColor: "#f06ec4",
  },
  progressLine: {
    width: "30px",
    height: "2px",
    backgroundColor: "#4a4a4a",
  },
  formCard: {
    width: "100%",
  },
  formHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
    alignContent: "center",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
    },
  },
  formIcon: {
    color: "#6baae8",
    marginRight: "10px",
  },
  formTitle: {
    color: "#EDECED",
    fontSize: "19px",
    fontWeight: 700,
  },
  formDescription: {
    color: "#EDECED",
    fontSize: "14px",
    fontWeight: 400,
    textAlign: "center",
    marginBottom: "20px",
    lineHeight: 1.5,
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px",
      marginBottom: "10px",
    },
  },
  formContent: {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    padding: "30px",
  },
  inputRow: {
    display: "flex",
    gap: "20px",
    marginBottom: "20px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  inputField: {
    flex: 1,
  },
  inputLabel: {
    fontSize: "14px",
    color: "#333333",
    marginBottom: "8px",
  },
  dateInput: {
    width: "100%",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "baseline",
    // marginTop: "25px",
    gap: "15px",
    [theme.breakpoints.down("xs")]: {
      // justifyContent: "center",
    },
  },
  skipLink: {
    color: "#f06ec4",
    fontSize: "14px",
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px",
    },
  },
  nextButton: {
    backgroundColor: "#f06ec4",
    color: "#ffffff",
    borderRadius: "30px",
    padding: "5px 20px",

    fontWeight: 700,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#d45aa8",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px",
    },
  },
  buttonIcon: {
    marginLeft: "5px",
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(99, 102, 241, 0.1)",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
  },
  AgreementAccepted: {
    color: "#ffffff",
    [theme.breakpoints.down("xs")]: {
      marginTop: "15px",
    },
  },
}));

export default completeProfileStyle;
